import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { setStore } from "./utils/storeAccessor";
import store from "./store";
import { Provider } from "react-redux";

setStore(store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
